import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getAuthToken } from '../utils/authToken';
import './PlatformAdminPage.css';

const PIc = {
  grid: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="2.5" y="2.5" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="2.5" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2.5" y="10" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="10" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  build: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M3 15V7l6-4 6 4v8" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 15v-4h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  card: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="2.5" y="4" width="13" height="10" rx="1.6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.5 7.5h13" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  pulse: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M2 9h3l2-5 4 10 2-5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  flag: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M5 16V3M5 3h8l-1.6 2.6L13 8H5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 18 18" width="16" height="16" fill="none">
      <circle cx="8" cy="8" r="5" stroke="currentColor" strokeWidth="1.6" />
      <path d="M12 12l3.5 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  enter: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M9.5 2.5H4a1 1 0 00-1 1v9a1 1 0 001 1h5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 8h7M11.5 5.5L14 8l-2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  up: (
    <svg viewBox="0 0 12 12" width="11" height="11" fill="none">
      <path d="M6 9.5V3M6 3L3 6M6 3l3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  down: (
    <svg viewBox="0 0 12 12" width="11" height="11" fill="none">
      <path d="M6 2.5V9M6 9L3 6M6 9l3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  dot: (
    <svg viewBox="0 0 8 8" width="8" height="8">
      <circle cx="4" cy="4" r="4" fill="currentColor" />
    </svg>
  ),
  queue: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M6.5 5h8.5M6.5 9h8.5M6.5 13h8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="3" cy="5" r="1.3" fill="currentColor" />
      <circle cx="3" cy="9" r="1.3" fill="currentColor" />
      <circle cx="3" cy="13" r="1.3" fill="currentColor" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <rect x="2" y="3.5" width="12" height="9" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.6 4.5L8 8.5l5.4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 16 16" width="13" height="13" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 5v3.2l2 1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  close: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  warn: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M8 2L1.5 13.5h13L8 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 6.5v3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.8" r="0.7" fill="currentColor" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M3 8.5l3.5 3.5L13 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <circle cx="6.5" cy="6" r="2.6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.5 14.5c0-2.2 1.8-3.6 4-3.6s4 1.4 4 3.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 4.2a2.4 2.4 0 010 4.6M13.2 14.5c0-1.9-1-3.1-2.4-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  tools: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M11.5 3.2a3 3 0 00-3.9 3.7L3 11.5l-.5 3 3-.5 4.6-4.6a3 3 0 003.7-3.9l-1.9 1.9-1.6-.4-.4-1.6 1.9-1.9z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  ),
  logs: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="3" y="2.5" width="12" height="13" rx="1.6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6 6h6M6 9h6M6 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  ai: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="3.5" y="5" width="11" height="9" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 5V2.6M6.5 9.5v1.5M11.5 9.5v1.5M1.8 9h1.7M14.5 9h1.7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  support: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <circle cx="9" cy="9" r="6.3" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7.2 7.2a1.9 1.9 0 113 2.1c-.7.5-1.2.9-1.2 1.7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="9" cy="13" r="0.7" fill="currentColor" />
    </svg>
  ),
  external: (
    <svg viewBox="0 0 14 14" width="12" height="12" fill="none">
      <path d="M5.5 3H3.5a1 1 0 00-1 1v6.5a1 1 0 001 1H10a1 1 0 001-1V8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M8 3h3v3M11 3L6.5 7.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  refresh: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M13 8a5 5 0 11-1.5-3.6M13 2.5V5h-2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  logo: (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M10 2.5l6.5 3.75v7.5L10 17.5l-6.5-3.75v-7.5L10 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 7.5v5M7.5 9l5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
};

// Plan label → colour tone for the pill / bar classes from the stylesheet.
const planTone = (label) => {
  const l = String(label || '').toLowerCase();
  if (l === 'essential') return 'team';
  if (l === 'growth') return 'biz';
  if (l === 'scale') return 'ent';
  return 'trial';
};
const STATUS_TONE = { active: 'ok', trial: 'info', past_due: 'warn', canceled: 'muted' };
const STATUS_LABEL = { active: 'Active', trial: 'Trial', past_due: 'Past due', canceled: 'Canceled' };
const WL_STATUS_LABEL = { waiting: 'Waiting', invited: 'Invited' };

const avatarBg = (id) => {
  const palette = ['var(--pa-av-0)', 'var(--pa-av-1)', 'var(--pa-av-2)', 'var(--pa-av-3)', 'var(--pa-av-4)'];
  return palette[(id || '').length % palette.length];
};

// "£26.3k" style compact money.
const fmtMoney = (n) => {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1000) return '£' + (v / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return '£' + v.toLocaleString();
};

const relTime = (iso) => {
  if (!iso) return '—';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '—';
  const s = Math.floor((Date.now() - t) / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'yesterday';
  if (d < 30) return `${d} d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

const Spark = ({ data, color, w = 150, h = 40, fill = true }) => {
  const series = Array.isArray(data) && data.length ? data : [0, 0];
  const pad = 3;
  const max = Math.max(...series);
  const min = Math.min(...series);
  const r = max - min || 1;
  const step = (w - pad * 2) / (series.length - 1 || 1);
  const pts = series.map((v, i) => [pad + i * step, h - pad - ((v - min) / r) * (h - pad * 2)]);
  const d = pts.map((p, i) => (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
  return (
    <svg className="pa-spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" fill="none">
      {fill && (
        <path
          d={`${d} L ${pts[pts.length - 1][0]} ${h} L ${pts[0][0]} ${h} Z`}
          fill={color}
          opacity="0.13"
        />
      )}
      <path d={d} stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const Stat = ({ label, value, delta, arrow, tone, spark, color }) => (
  <div className="pa-stat">
    <div className="pa-stat-l">{label}</div>
    <div className="pa-stat-v">{value}</div>
    <div className="pa-stat-row">
      {delta && (
        <span className={`pa-delta ${tone || ''}`}>
          {arrow === 'down' ? PIc.down : arrow === 'up' ? PIc.up : null}
          {delta}
        </span>
      )}
      {spark && <Spark data={spark} color={color} w={108} h={28} />}
    </div>
  </div>
);

const EmptyRow = ({ cols, label }) => (
  <tr>
    <td colSpan={cols} style={{ textAlign: 'center', color: 'var(--pa-ink-4)', padding: '28px 16px' }}>
      {label}
    </td>
  </tr>
);

/* -------------------- Overview -------------------- */
const Overview = ({ overview, system, onGo }) => {
  const totals = overview?.totals || {};
  const events = overview?.recentEvents || [];
  const services = system?.services || [];
  const allOk = services.every((s) => s.status === 'ok');
  return (
    <div className="pa-view">
      <div className="pa-grid-4">
        <Stat label="MRR" value={fmtMoney(overview?.mrr)} delta="recurring" tone="ok" spark={overview?.signupsTrend} color="var(--pa-accent)" />
        <Stat label="Active accounts" value={(totals.active || 0).toLocaleString()} delta={`${totals.users || 0} total`} tone="info" spark={overview?.signupsTrend} color="#2da06a" />
        <Stat label="Paid accounts" value={(totals.paid || 0).toLocaleString()} delta={`${totals.verified || 0} verified`} tone="ok" />
        <Stat label="Trials in flight" value={(totals.trial || 0).toLocaleString()} delta={`${totals.onlineNow || 0} online now`} tone="info" />
      </div>

      <div className="pa-row-2">
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Recent activity</h3>
            <button type="button" className="pa-link" onClick={() => onGo('workspaces')}>
              All accounts {PIc.enter}
            </button>
          </div>
          <div className="pa-events">
            {events.length === 0 && (
              <div className="pa-event"><span className="pa-ev-b" style={{ color: 'var(--pa-ink-4)' }}>No recent activity yet.</span></div>
            )}
            {events.map((e, i) => (
              <div className="pa-event" key={i}>
                <span className={`pa-ev-dot ${e.tone}`}>{PIc.dot}</span>
                <div className="pa-ev-b">
                  <b>{e.title}</b> {e.subtitle}
                </div>
                <span className="pa-ev-t">{relTime(e.time)}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="pa-card">
          <div className="pa-card-h">
            <h3>System status</h3>
            <span className={`pa-status-pill ${allOk ? 'ok' : ''}`}>
              {allOk ? PIc.check : PIc.warn} {allOk ? 'Operational' : 'Degraded'}
            </span>
          </div>
          <div className="pa-services">
            {services.map((s) => (
              <div className="pa-service" key={s.name}>
                <span className={`pa-svc-dot ${s.status}`}></span>
                <span className="pa-svc-n">{s.name}</span>
                <span className="pa-svc-note">{s.note}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/* -------------------- Accounts / workspaces -------------------- */
const WorkspaceDir = ({ workspaces, onManage }) => {
  const [q, setQ] = useState('');
  const [plan, setPlan] = useState('All');
  const plans = ['All', 'Free', 'Essential', 'Growth', 'Scale'];
  const rows = (workspaces || []).filter(
    (w) =>
      (plan === 'All' || w.plan === plan) &&
      (!q ||
        (w.name || '').toLowerCase().includes(q.toLowerCase()) ||
        (w.slug || '').includes(q.toLowerCase()) ||
        (w.email || '').toLowerCase().includes(q.toLowerCase()))
  );
  return (
    <div className="pa-view">
      <div className="pa-toolbar">
        <div className="pa-search">
          {PIc.search}
          <input
            placeholder="Search accounts, usernames, emails…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="pa-seg">
          {plans.map((p) => (
            <button key={p} type="button" className={plan === p ? 'on' : ''} onClick={() => setPlan(p)}>
              {p}
            </button>
          ))}
        </div>
        <div className="grow"></div>
        <span className="pa-count">
          {rows.length} of {(workspaces || []).length}
        </span>
      </div>

      <div className="pa-card pa-tablewrap">
        <table className="pa-table">
          <thead>
            <tr>
              <th>Account</th>
              <th>Plan</th>
              <th className="num">MRR</th>
              <th>Status</th>
              <th>Joined</th>
              <th>Last active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <EmptyRow cols={7} label="No accounts match your search." />}
            {rows.map((w) => (
              <tr key={w.id}>
                <td>
                  <div className="pa-ws">
                    <span className="pa-ws-av" style={{ background: avatarBg(w.id) }}>
                      {(w.name || '?')[0].toUpperCase()}
                    </span>
                    <div className="pa-ws-b">
                      <b>{w.name}{w.isAdmin ? ' · admin' : ''}</b>
                      <span>{w.email}{w.company ? ` · ${w.company}` : ''}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={`pa-plan ${planTone(w.plan)}`}>{w.plan}</span>
                </td>
                <td className="num">{w.mrr ? fmtMoney(w.mrr) : '—'}</td>
                <td>
                  <span className={`pa-st ${STATUS_TONE[w.status]}`}>{STATUS_LABEL[w.status]}</span>
                </td>
                <td className="muted">{relTime(w.createdAt)}</td>
                <td className="muted">{w.isOnline ? 'online' : relTime(w.lastOnline)}</td>
                <td className="right">
                  <button
                    type="button"
                    className="pa-imp-btn"
                    onClick={onManage}
                    title="Open in User Management"
                  >
                    {PIc.enter}
                    <span>Manage</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* -------------------- Billing & revenue -------------------- */
const Billing = ({ overview }) => {
  const breakdown = (overview?.planBreakdown || []);
  const paidPlans = breakdown.filter((p) => p.mrr > 0);
  const total = paidPlans.reduce((a, p) => a + p.mrr, 0) || 0;
  return (
    <div className="pa-view">
      <div className="pa-grid-4">
        <Stat label="MRR" value={fmtMoney(overview?.mrr)} delta="recurring" tone="ok" />
        <Stat label="ARR (run-rate)" value={fmtMoney(overview?.arr)} delta="× 12 MRR" tone="ok" />
        <Stat label="Paid accounts" value={(overview?.totals?.paid || 0).toLocaleString()} delta="billing" tone="info" />
        <Stat label="Trials" value={(overview?.totals?.trial || 0).toLocaleString()} delta="converting" tone="info" />
      </div>
      <div className="pa-row-2">
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>MRR by plan</h3>
            <span className="pa-muted-note">Monthly recurring</span>
          </div>
          <div className="pa-bars">
            {paidPlans.length === 0 && (
              <div style={{ color: 'var(--pa-ink-4)', fontSize: 13 }}>No paid accounts yet.</div>
            )}
            {paidPlans.map((p) => (
              <div className="pa-bar-row" key={p.key}>
                <span className="pa-bar-l">{p.label}</span>
                <span className="pa-bar-track">
                  <span
                    className={`pa-bar ${planTone(p.label)}`}
                    style={{ width: (total ? (p.mrr / total) * 100 : 0) + '%' }}
                  ></span>
                </span>
                <span className="pa-bar-v">{fmtMoney(p.mrr)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Accounts by plan</h3>
            <span className="pa-muted-note">All accounts</span>
          </div>
          <div className="pa-events">
            {breakdown.map((p) => (
              <div className="pa-event" key={p.key}>
                <span className={`pa-ev-dot ${p.mrr > 0 ? 'ok' : 'muted'}`}>{PIc.dot}</span>
                <div className="pa-ev-b">
                  <b>{p.label}</b> · {p.count.toLocaleString()} {p.count === 1 ? 'account' : 'accounts'}
                </div>
                <span className="pa-ev-t">{p.mrr > 0 ? `${fmtMoney(p.mrr)}/mo` : 'free'}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/* -------------------- Waiting list -------------------- */
const WaitingList = ({ waitlist, token, onChanged }) => {
  const [q, setQ] = useState('');
  const [seg, setSeg] = useState('All');
  const [busyId, setBusyId] = useState(null);
  const segs = ['All', 'Waiting', 'Invited'];

  const rows = waitlist?.entries || [];
  const totals = waitlist?.totals || { total: 0, invited: 0, waiting: 0 };
  const sources = waitlist?.sources || [];
  const trend = waitlist?.joinsTrend || [];

  const counts = {
    All: rows.length,
    Waiting: rows.filter((r) => r.status === 'waiting').length,
    Invited: rows.filter((r) => r.status === 'invited').length,
  };
  const view = rows.filter(
    (r) =>
      (seg === 'All' || WL_STATUS_LABEL[r.status] === seg) &&
      (!q ||
        (r.email || '').toLowerCase().includes(q.toLowerCase()) ||
        (r.source || '').toLowerCase().includes(q.toLowerCase()))
  );

  const invite = async (id) => {
    if (!token) return;
    setBusyId(id);
    try {
      await axios.post(`/api/admin/platform/waitlist/${id}/invite`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      onChanged();
    } catch (err) {
      window.alert(err.response?.data?.msg || 'Failed to invite.');
    } finally {
      setBusyId(null);
    }
  };

  const lastWeek = trend.length ? trend[trend.length - 1] : 0;
  const maxSource = Math.max(1, ...sources.map((s) => s.count));

  return (
    <div className="pa-view">
      <div className="pa-grid-4">
        <Stat label="On the waitlist" value={(totals.total || 0).toLocaleString()} delta={`+${lastWeek} this week`} arrow="up" tone="info" spark={trend} color="var(--pa-accent)" />
        <Stat label="Invited" value={(totals.invited || 0).toLocaleString()} delta="notified" tone="ok" />
        <Stat label="Still waiting" value={(totals.waiting || 0).toLocaleString()} delta="in queue" tone="info" />
        <Stat label="Joined this week" value={lastWeek.toLocaleString()} delta="last 7 days" tone="ok" />
      </div>

      <div className="pa-row-2">
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Requests over time</h3>
            <span className="pa-muted-note">Last 12 weeks</span>
          </div>
          <div className="pa-wl-trend">
            <Spark data={trend} color="var(--pa-accent)" w={420} h={104} />
            <div className="pa-wl-trend-foot">
              <span><b>{lastWeek}</b> joined this week</span>
              <span className="pa-delta info">{totals.total} total signups</span>
            </div>
          </div>
        </div>
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Top sources</h3>
            <span className="pa-muted-note">All-time signups</span>
          </div>
          <div className="pa-bars">
            {sources.length === 0 && (
              <div style={{ color: 'var(--pa-ink-4)', fontSize: 13 }}>No signups captured yet.</div>
            )}
            {sources.map((s, i) => (
              <div className="pa-bar-row" key={s.name}>
                <span className="pa-bar-l">{s.name}</span>
                <span className="pa-bar-track">
                  <span className={`pa-bar s${i % 5}`} style={{ width: (s.count / maxSource) * 100 + '%' }}></span>
                </span>
                <span className="pa-bar-v">{s.count.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pa-toolbar">
        <div className="pa-search">
          {PIc.search}
          <input placeholder="Search emails, sources…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <div className="pa-seg">
          {segs.map((s) => (
            <button key={s} type="button" className={seg === s ? 'on' : ''} onClick={() => setSeg(s)}>
              {s} <span className="pa-seg-c">{counts[s]}</span>
            </button>
          ))}
        </div>
        <div className="grow"></div>
        <span className="pa-count">{view.length} shown</span>
      </div>

      <div className="pa-card pa-tablewrap">
        <table className="pa-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Email</th>
              <th>Source</th>
              <th>Plan interest</th>
              <th className="num">Submissions</th>
              <th>Joined</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {view.length === 0 && <EmptyRow cols={8} label="No waitlist entries match your search." />}
            {view.map((r, idx) => (
              <tr key={r.id}>
                <td className="pa-pos">{idx + 1}</td>
                <td>
                  <div className="pa-ws">
                    <span className="pa-ws-av" style={{ background: avatarBg(r.id) }}>
                      {(r.email || '?')[0].toUpperCase()}
                    </span>
                    <div className="pa-ws-b">
                      <b>{r.email}</b>
                    </div>
                  </div>
                </td>
                <td><span className="pa-src">{r.source}</span></td>
                <td className="muted">{r.plan || '—'}</td>
                <td className="num">{r.submissionCount}</td>
                <td className="muted">{relTime(r.joined)}</td>
                <td><span className={`pa-wl-st ${r.status}`}>{WL_STATUS_LABEL[r.status]}</span></td>
                <td className="right">
                  {r.status === 'waiting' ? (
                    <button type="button" className="pa-invite" disabled={busyId === r.id} onClick={() => invite(r.id)}>
                      {PIc.mail}
                      <span>{busyId === r.id ? 'Inviting…' : 'Invite'}</span>
                    </button>
                  ) : (
                    <span className="pa-invited-tag">{PIc.check} Invited</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* -------------------- System status -------------------- */
const SystemView = ({ system }) => {
  const services = system?.services || [];
  const proc = system?.process || {};
  const db = system?.db || {};
  const fmtUptime = (s) => {
    if (!s) return '—';
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    return [d ? `${d}d` : '', h ? `${h}h` : '', `${m}m`].filter(Boolean).join(' ');
  };
  return (
    <div className="pa-view">
      <div className="pa-card">
        <div className="pa-card-h">
          <h3>Services</h3>
          <span className={`pa-status-pill ${services.every((s) => s.status === 'ok') ? 'ok' : ''}`}>
            {services.every((s) => s.status === 'ok') ? PIc.check : PIc.warn}{' '}
            {services.every((s) => s.status === 'ok') ? 'All systems operational' : 'Attention needed'}
          </span>
        </div>
        <div className="pa-services lg">
          {services.map((s) => (
            <div className="pa-service" key={s.name}>
              <span className={`pa-svc-dot ${s.status}`}></span>
              <span className="pa-svc-n">{s.name}</span>
              <span className="pa-svc-note">{s.note}</span>
              <span className={`pa-svc-tag ${s.status}`}>{s.status === 'ok' ? 'Operational' : 'Degraded'}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="pa-card">
        <div className="pa-card-h"><h3>Runtime</h3></div>
        <div className="pa-bars">
          <div className="pa-bar-row"><span className="pa-bar-l">Uptime</span><span></span><span className="pa-bar-v">{fmtUptime(proc.uptimeSeconds)}</span></div>
          <div className="pa-bar-row"><span className="pa-bar-l">Node</span><span></span><span className="pa-bar-v">{proc.nodeVersion || '—'}</span></div>
          <div className="pa-bar-row"><span className="pa-bar-l">Environment</span><span></span><span className="pa-bar-v">{proc.env || '—'}</span></div>
          <div className="pa-bar-row"><span className="pa-bar-l">Memory (RSS)</span><span></span><span className="pa-bar-v">{proc.memoryMB ? `${proc.memoryMB} MB` : '—'}</span></div>
          <div className="pa-bar-row"><span className="pa-bar-l">Database</span><span></span><span className="pa-bar-v">{db.connected ? `connected${db.name ? ` · ${db.name}` : ''}` : 'disconnected'}</span></div>
        </div>
      </div>
    </div>
  );
};

/* -------------------- Feature flags (local preview) -------------------- */
const FLAG_META = {
  'adaptive-ai-v3': 'Adaptive Rush AI drafting engine',
  'in-context-preview': 'Live overflow preview',
  'automations-builder': 'Continuous-localization rules',
  'brand-voice-studio': 'Per-language voice profiles',
  'byo-mt-engine': 'Bring-your-own MT (beta)',
  'sso-scim': 'SAML SSO + SCIM provisioning',
  'usage-billing': 'Usage-based billing (internal)',
};
const FLAG_DEFAULTS = {
  'adaptive-ai-v3': true,
  'in-context-preview': true,
  'automations-builder': true,
  'brand-voice-studio': true,
  'byo-mt-engine': false,
  'sso-scim': true,
  'usage-billing': false,
};
const FlagsView = () => {
  const [flags, setFlags] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('pa_feature_flags') || 'null');
      return saved && typeof saved === 'object' ? { ...FLAG_DEFAULTS, ...saved } : FLAG_DEFAULTS;
    } catch (_) {
      return FLAG_DEFAULTS;
    }
  });
  const toggle = (k) =>
    setFlags((f) => {
      const next = { ...f, [k]: !f[k] };
      try { localStorage.setItem('pa_feature_flags', JSON.stringify(next)); } catch (_) { /* ignore */ }
      return next;
    });
  return (
    <div className="pa-view">
      <div className="pa-card">
        <div className="pa-card-h">
          <h3>Feature flags</h3>
          <span className="pa-muted-note">Saved to this browser — backend rollout wiring pending</span>
        </div>
        <div className="pa-flags">
          {Object.keys(FLAG_META).map((k) => (
            <div className="pa-flag" key={k}>
              <div className="pa-flag-b">
                <code>{k}</code>
                <span>{FLAG_META[k]}</span>
              </div>
              <button
                type="button"
                className={`pa-switch ${flags[k] ? 'on' : ''}`}
                role="switch"
                aria-checked={flags[k]}
                onClick={() => toggle(k)}
              >
                <span></span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const NAV = [
  ['overview', 'Overview', PIc.grid],
  ['workspaces', 'Accounts', PIc.build],
  ['waitlist', 'Waiting list', PIc.queue],
  ['billing', 'Billing & revenue', PIc.card],
  ['system', 'System status', PIc.pulse],
  ['flags', 'Feature flags', PIc.flag],
];

const TITLE_OF = {
  overview: 'Overview',
  workspaces: 'Accounts',
  waitlist: 'Waiting list',
  billing: 'Billing & revenue',
  system: 'System status',
  flags: 'Feature flags',
};

// Existing admin utility pages, surfaced from the console rail.
const ADMIN_TOOLS = [
  ['User management', PIc.users, '/dashboard/admin/users'],
  ['Utilities', PIc.tools, '/dashboard/admin/utilities'],
  ['System logs', PIc.logs, '/dashboard/admin/logs'],
  ['AI usage', PIc.ai, '/dashboard/admin/ai-usage'],
  ['MT account usage', PIc.pulse, '/dashboard/admin/deepl-usage'],
  ['Support manager', PIc.support, '/dashboard/admin/support'],
  ['Support tickets', PIc.mail, '/dashboard/admin/support-tickets'],
];

const PlatformAdminPage = () => {
  const [view, setView] = useState('overview');
  const [overview, setOverview] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [waitlist, setWaitlist] = useState(null);
  const [system, setSystem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const tokenFromState = useSelector((state) => state.auth.token);
  const token = getAuthToken(tokenFromState);

  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = '#fbfaf7';
    return () => {
      document.body.style.background = prev;
    };
  }, []);

  const fetchAll = useCallback(async () => {
    if (!token) {
      setError('Authentication token missing. Please sign in again.');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const [ov, ws, wl, sys] = await Promise.all([
        axios.get('/api/admin/platform/overview', { headers }),
        axios.get('/api/admin/platform/workspaces', { headers }),
        axios.get('/api/admin/platform/waitlist', { headers }),
        axios.get('/api/admin/platform/system', { headers }),
      ]);
      setOverview(ov.data);
      setWorkspaces(ws.data?.workspaces || []);
      setWaitlist(wl.data);
      setSystem(sys.data);
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to load platform data.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const refetchWaitlist = useCallback(async () => {
    if (!token) return;
    try {
      const wl = await axios.get('/api/admin/platform/waitlist', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWaitlist(wl.data);
    } catch (_) {
      /* keep the existing data on a soft refresh failure */
    }
  }, [token]);

  const goManageUsers = useCallback(() => navigate('/dashboard/admin/users'), [navigate]);

  const body = useMemo(() => {
    if (loading) {
      return (
        <div className="pa-loading">
          <span className="pa-spinner" /> Loading live platform data…
        </div>
      );
    }
    if (error) {
      return (
        <div className="pa-error">
          {PIc.warn} {error}
          <button type="button" className="pa-btn" onClick={fetchAll} style={{ marginLeft: 12 }}>
            {PIc.refresh} Retry
          </button>
        </div>
      );
    }
    switch (view) {
      case 'overview':
        return <Overview overview={overview} system={system} onGo={setView} />;
      case 'workspaces':
        return <WorkspaceDir workspaces={workspaces} onManage={goManageUsers} />;
      case 'waitlist':
        return <WaitingList waitlist={waitlist} token={token} onChanged={refetchWaitlist} />;
      case 'billing':
        return <Billing overview={overview} />;
      case 'system':
        return <SystemView system={system} />;
      case 'flags':
        return <FlagsView />;
      default:
        return null;
    }
  }, [view, loading, error, overview, workspaces, waitlist, system, token, fetchAll, refetchWaitlist, goManageUsers]);

  return (
    <div className="pa-app">
      <aside className="pa-rail">
        <div className="pa-brand">
          <span className="pa-brand-mark">{PIc.logo}</span>
          <div className="pa-brand-t">
            <b>Rush Studio</b>
            <span>Platform console</span>
          </div>
        </div>
        <div className="pa-staff-badge">{PIc.warn} Staff · internal</div>
        <nav className="pa-nav">
          {NAV.map(([id, label, ic]) => (
            <button
              type="button"
              key={id}
              className={`pa-nav-i ${view === id ? 'on' : ''}`}
              onClick={() => setView(id)}
            >
              <span className="ic">{ic}</span>
              {label}
            </button>
          ))}
        </nav>

        <div className="pa-nav-label">Admin tools</div>
        <nav className="pa-nav">
          {ADMIN_TOOLS.map(([label, ic, path]) => (
            <button type="button" key={path} className="pa-nav-i" onClick={() => navigate(path)}>
              <span className="ic">{ic}</span>
              {label}
              <span className="pa-nav-ext">{PIc.external}</span>
            </button>
          ))}
        </nav>

        <div className="pa-rail-foot">
          <div className="pa-env">
            <span className="dot"></span>
            {system?.process?.env ? system.process.env.charAt(0).toUpperCase() + system.process.env.slice(1) : 'Production'}
          </div>
          <div className="pa-op">
            <span className="pa-op-av">OP</span>
            <div className="pa-op-b">
              <b>You</b>
              <span>Platform operator</span>
            </div>
          </div>
        </div>
      </aside>

      <div className="pa-main">
        <header className="pa-head">
          <div>
            <div className="pa-crumb">
              Platform <span>/</span> {TITLE_OF[view]}
            </div>
            <h1>{TITLE_OF[view]}</h1>
          </div>
          <div className="pa-head-r">
            <button type="button" className="pa-refresh" onClick={fetchAll} disabled={loading}>
              {PIc.refresh} {loading ? 'Refreshing…' : 'Refresh'}
            </button>
            <span className="pa-region">All regions · GBP</span>
          </div>
        </header>

        <div className="pa-body">{body}</div>
      </div>
    </div>
  );
};

export default PlatformAdminPage;
